<template>
  <div>
    <div class="container" v-if="isShow">
      <div class="card" style="padding: 5px">
        <div class="tagTitle">
          <van-tag type="success">收款信息</van-tag>
          <van-tag :type="typeArr[payInfo.checkStatus]" plain style="margin-right: 15px">{{statusArr[payInfo.checkStatus]}}</van-tag>
        </div>
        <div class="list-wrap van-hairline--top">
          <div class="item" >
            <span class="key">付款单位：</span>
            <span class="value">{{ payInfo.custName }}</span>
          </div>
          <div class="item" >
            <span class="key">可认领：</span>
            <span class="value" style="color: #F56C6C">
              ￥{{payInfo.noConfirmMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.noConfirmMoney)}}</span>
            </span>
          </div>
          <div class="item" >
            <span class="key">已认领：</span>
            <span class="value" style="color: #F56C6C">
              ￥{{payInfo.confirmMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.confirmMoney)}}</span>
            </span>
          </div>
          <div class="item" >
            <span class="key">待确认：</span>
            <span class="value" style="color: #F56C6C">
              ￥{{payInfo.totalMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(payInfo.totalMoney)}}</span>
            </span>
          </div>
          <div class="item" >
            <span class="key">收款主体：</span>
            <span class="value">{{ payInfo.companyName }}</span>
          </div>
          <div class="item" >
            <span class="key">收款账号：</span>
            <span class="value">{{ payInfo.payBank + '  ' + payInfo.payBankAccountNo}}</span>
          </div>
          <div class="item">
            <span class="key">收款时间：</span>
            <span class="value">{{payInfo.payDate}}</span>
          </div>
          <div class="item">
            <span class="key">添加信息：</span>
            <span class="value">{{payInfo.createBy + '  ' + payInfo.createTime}}</span>
          </div>
        </div>
      </div>
      <div class="card" style="padding: 5px">
        <van-tag type="warning" style="margin-top: 5px;">认领信息</van-tag>
        <div class="list-wrap van-hairline--top">
          <div class="item">
            <span class="key">合同编号：</span>
            <span class="value">{{ detailInfo.contractNum }}</span>
          </div>
          <div class="item">
            <span class="key">合同名称：</span>
            <span class="value">{{ detailInfo.contractName }}</span>
          </div>
          <div class="item">
            <span class="key">认领信息：</span>
            <span class="value">{{ detailInfo.deptName }} {{ detailInfo.userName }}</span>
          </div>
          <div class="item">
            <span class="key">认领金额：</span>
            <span class="value" style="color: #F56C6C">
              ￥{{detailInfo.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(detailInfo.payMoney)}}</span>
            </span>
          </div>
          <div class="item" v-if="detailInfo.getStatus == 5">
            <span class="key">付款截图：</span>
            <van-button type="info" size="mini" plain @click="showImg('payImg')" v-if="detailInfo.payImg">点击查看</van-button>
            <span class="value" v-else>无</span>
          </div>
          <div class="item" v-if="detailInfo.getStatus == 5">
            <span class="key">异议原因：</span>
            <span class="value">{{ detailInfo.reason }}</span>
          </div>
        </div>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="2" v-if="isConfirm">
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newIncomeDetail:msgConfirm']" @click="handleConfirm(payInfo.contNewIncomeId)">
            <van-icon name="certificate" size="22" color="#1989fa" />
            <span>确认</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" v-hasPermi="['cont:newIncomeDetail:noAgreeMatch']" @click="handleClaim(payInfo,'noAgreeMatch')">
            <van-icon name="failure" size="22" color="#ee0a24" />
            <span>提交异议</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-dialog v-model="claimVisible" title="提交异议" width="95%" style="height:80%" class="verifyClue" :beforeClose="claimBeforeClose" show-cancel-button>
        <van-form ref="claimForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
          <van-field readonly clickable v-model="claimForm.contractName" @click="showPicker('contract')" label="合同信息" placeholder="请选择合同信息" :rules="[{ required: true }]" required />
          <van-collapse v-model="activeDetail">
            <van-collapse-item title="查看合同详情" name="1">
              <div>
                <div class="item">
                  <span class="key">我方签约主体机构：</span>
                  <span class="value">{{ contInfo.companyName }}</span>
                </div>
                <div class="item">
                  <span class="key">合同执行时间：</span>
                  <span class="value">{{ contInfo.startTime }}至{{ contInfo.endTime }}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">垫款方式：</span>
                  <span class="value">{{formatHandel('payType',contInfo.payType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">框架类型：</span>
                  <span class="value">{{formatHandel('frameType',contInfo.frameType)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">客户来源：</span>
                  <span class="value">{{formatHandel('custSource',contInfo.custSource)}}</span>
                </div>
                <div class="item" style="width: 48%">
                  <span class="key">授信账期：</span>
                  <span class="value">{{contInfo.creditCycleType?`${contInfo.creditCycleValue}个${formatHandel('creditCycleType',contInfo.creditCycleType)}`:'--'}}</span>
                </div>
                <div class="item">
                  <span class="key">合同金额(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.contractMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.contractMoney)}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">合同累计回款(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.allReturnedMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.allReturnedMoney)}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">合同授信额度(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.advancesMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.advancesMoney)}}</span>
                  </span>
                </div>
                <div class="item">
                  <span class="key">累计垫款总额(元)：</span>
                  <span class="value" style="color: #F56C6C">
                    ￥{{contInfo.creditTotalMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(contInfo.creditTotalMoney)}}</span>
                  </span>
                </div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <van-cell title="回款状态：" required>
            <template>
              <van-radio-group v-model="claimForm.incomeType" direction="horizontal" :disabled="contInfo.creditTotalMoney<=0 || !contInfo.creditTotalMoney">
                <van-radio :name="0" clickable>正常回款</van-radio>
                <van-radio :name="1" clickable>垫款回款</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <!-- :disabled="payMoneyDisabled"  -->
          <van-field v-model="claimForm.payMoney" label="确认金额(元)" placeholder="请输入确认金额" @blur="getSum('payMoney')" :rules="[{ required: true }]" type="number" maxlength="11" required />
          <van-cell title="提示信息：确认金额为当前合同本次收款的金额" style="color: #ff976a;"></van-cell>
          <template v-if="isObjection">
            <van-field v-model="claimForm.payImg" label="付款截图" placeholder="请点击下方上传付款截图" :rules="[{ required: true }]" required readonly />
            <van-uploader class="pictureList" v-model="pictureList" :max-count="1" :after-read="uploadPictureFiles" :before-read="beforeRead" :before-delete="handleRemove" @oversize="onOversize" :max-size="10000 * 1024" />
            <van-field v-model="claimForm.reason" label="异议原因" placeholder="请输入异议原因" type="text" :rules="[{ required: true }]" required />
          </template>
          <van-field v-model="claimForm.remark" rows="2" autosize label="备注" placeholder="备注信息" type="textarea" show-word-limit />
          <van-button v-if="claimForm.flowList.length == 0 && this.contInfo.contractId" class="topBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+增加分账明细</van-button>
          <van-collapse v-model="activeNames">
            <van-collapse-item :title="'分账明细'+(index+1)" :name="index" v-for="(item,index) in claimForm.flowList" :key="index+'01'">
              <van-field v-model="item.fundTypeName" label="资金类型" placeholder="请选择资金类型" readonly clickable  @click="showPicker('fundType',index)" :rules="[{ required: true }]" required />
              <van-field v-if="item.fundType == 1 || item.fundType == 2" v-model="item.rechargeMoney" label="账户币" placeholder="请输入账户币" @blur="getPayMoney('rechargeMoney',item.rechargeMoney,index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
              <van-field v-model="item.payMoney" label="现金金额(元)" placeholder="请输入现金金额" @blur="getPayMoney('payMoney',item.payMoney,index)" type="number" maxlength="11" :rules="[{ required: true }]" required />
              <div class="link">
                <van-button class="linkaddBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+分账明细</van-button>
                <van-button class="linkaddBtn" round block type="warning" native-type="button" size="small" @click="deleteExecutive(index)">删除</van-button>
              </div>
            </van-collapse-item>
          </van-collapse>
        </van-form>
      </van-dialog>
      <van-image-preview v-model="imageShow" :images="imageArr">
        <!-- <template v-slot:index>第{{ index }}页</template> -->
      </van-image-preview>
      <van-popup v-model="picker.visible" position="bottom">
        <van-picker :loading="picker.loading" :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
// import { getDicts } from '@/api/system/dict/data'
import newContract from '@/api/cont/newContract'
import { Toast, Dialog, ImagePreview } from 'vant'
// import Empty from '@/components/common/Empty'
let api = null
export default {
  components: {
    // Empty,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      type: null,
      typeDetail: null,
      typeMsg: null,

      isShow: false,
      active: 0,
      activeName: '',
      contNewIncomeId: '',
      paymentFormShow: false,
      contForm: {},
      pointList: [],
      executiveList: [],
      finished: true,
      payInfo: {},
      operationLogList: [], // 操作日志
      contractFileList: [], // 合同附件
      fileFinished: true,
      verifyFormShow: false,
      verifyForm: {
        checkStatus: '2',
        checkReason: '',
        contIncomeId: ''
      },
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      styleArr: ['success', 'warning', 'primary', 'danger'],
      statusArr: ['', '未认领公海', '未认领', '部分认领', '已认领', '异常'],
      typeArr: ['', 'danger', 'danger', 'warning', 'success', 'primary'],
      options: {
        checkStatusOptions: [],
        frameTypeOptions: [],
        fundTypeOptions: [],
        checkReasonTypeOptions: [],
        fileTypeOptions: [],
        creditCycleTypeOptions: []
      },
      imageShow: false,
      imageArr: [],
      historicalClaimList: [],
      getStatus: [],
      claimVisible: false,
      claimForm: {
        incomeType: null,
        payMoney: null,
        contractId: null,
        contactName: null,
        flowList: [] // 分账明细
      },
      pictureList: [],
      contInfo: {}, // 合同信息
      isObjection: false, // 是否异议
      payMoneyDisabled: false, // 金额是否可输入
      activeDetail: [],
      contractId: null,
      newIncomeContList: [],
      detailInfo: {},
      contNewIncomeMsgId: '',
      claimedMoney: 0,
      isConfirm: false,

      // 分账
      index: null,
      activeNames: [0]
    }
  },
  async created() {
    const { contNewIncomeId, contNewIncomeDetailId, contNewIncomeMsgId, type } = this.$route.query
    if (type == 'payment') {
      api = payment
      this.type = 'contNewIncomeId'
      this.typeDetail = 'contNewIncomeDetailId'
      this.typeMsg = 'contNewIncomeMsgId'
    } else if (type == 'channel') {
      api = channel
      this.type = 'needId'
      this.typeDetail = 'needDetailId'
      this.typeMsg = 'needMsgId'
    }
    this.contNewIncomeId = contNewIncomeId
    await this.getOptions()
    await this.getPayInfo(contNewIncomeId)
    await this.getDetailInfo(contNewIncomeDetailId)
    this.contNewIncomeMsgId = contNewIncomeMsgId
    await this.getMsgInfo(contNewIncomeMsgId)
    // this.getDicts('check_reason_type').then(res => {
    //   this.options.checkReasonTypeOptions = this.setDictToInt(res)
    // })
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '收款详情'
    },
    async getPayInfo(contNewIncomeId) {
      const res = await api.getNewIncome(contNewIncomeId)
      if (res.code === 200) {
        this.payInfo = res.data
        this.isShow = true
      }
      // payment.getGetTotalMoney({ contNewIncomeId: res.data.contNewIncomeId }).then(response => {
      //   if (response.code == 200) {
      //     this.claimedMoney = response.data
      //   }
      // })
      // if (res.data.checkStatus == 3 || res.data.checkStatus == 4 || res.data.checkStatus == 5) {
      //   switch (res.data.checkStatus) {
      //     case 3: { this.getStatus = 3; break }
      //     case 4: { this.getStatus = 1; break }
      //     case 5: { this.getStatus = 4; break }
      //   }
      //   payment.listNewIncomeDetail({ contNewIncomeId: res.data.contNewIncomeId, getStatus: this.getStatus }).then(response => {
      //     if (response.code == 200) {
      //       this.historicalClaimList = response.rows
      //     }
      //   })
      // }
      // this.getLogList()
    },
    async getDetailInfo(contNewIncomeDetailId) {
      const res = await api.getNewIncomeDetail(contNewIncomeDetailId)
      if (res.code === 200) {
        this.detailInfo = res.data
      }
    },
    async getMsgInfo(contNewIncomeMsgId) {
      const res = await api.getMsg(contNewIncomeMsgId)
      if (res.code === 200) {
        this.isConfirm = res.data.getStatus != 2
      }
    },
    handleConfirm() {
      Dialog.confirm({
        message: '是否确认通过此条认领记录'
      })
        .then(() => {
          api.msgConfirm({ [this.typeMsg]: this.contNewIncomeMsgId }).then(res => {
            if (res.code === 200) {
              Toast.success('确认成功')
              setTimeout(() => {
                this.$router.push({
                  path: '/cont/payment/paymentDetail',
                  query: { id: this.contNewIncomeId, type: this.$route.query.type }
                })
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.contNewIncomeId,
        bigType: 4
      }
      newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'contract') {
        this.picker.columns = this.newIncomeContList.map((ele) => ele.contractNum + '  ' + ele.contractName)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      const name = this.picker.formKey + 'Name'
      // const id = this.picker.formKey + 'Id'
      if (this.index || this.index == 0) {
        this.claimForm.flowList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
        this.claimForm.flowList[this.index][name] = this.options[optionItem][key].dictLabel
      } else {
        if (this.picker.formKey === 'contract') {
          this.newIncomeContList = this.newIncomeContList.filter(item => {
            return item.contractName.indexOf(this.searchValue) > -1 || item.contractNum.indexOf(this.searchValue) > -1
          })
          this.claimForm.contractId = this.newIncomeContList[key].contractId
          this.claimForm.contractName = this.newIncomeContList[key].contractNum + '  ' + this.newIncomeContList[key].contractName
          newContract.getContract(this.claimForm.contractId).then(res => {
            this.contInfo = res.data
          })
          this.getIncomeType(this.claimForm.contractId)
        } else {
          this.verifyForm[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.verifyForm[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    async remove(contNewIncomeId) {
      Dialog.confirm({
        message: '是否确认删除此条打款记录'
      })
        .then(() => {
          api.deleteNewIncome(contNewIncomeId).then(res => {
            if (res.code === 200) {
              Toast.success('删除成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleUnbind(contNewIncomeDetailId) {
      Dialog.confirm({
        message: '是否确认解除该收款记录认领的记录吗？'
      })
        .then(() => {
          api.relieve({ [this.typeDetail]: contNewIncomeDetailId }).then(res => {
            if (res.code === 200) {
              Toast.success('解除成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    notMine(contNewIncomeId) {
      Dialog.confirm({
        message: '是否确认这条数据不是你的?'
      })
        .then(() => {
          api.addNewIncomeDetail({ [this.type]: contNewIncomeId, status: 3 }).then(res => {
            if (res.code === 200) {
              Toast.success('操作成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    handleClaim(val, type) {
      if (type == 'noAgreeMatch') {
        this.isObjection = true
      } else {
        this.isObjection = false
      }
      // this.$refs.claimForm.resetFields()
      if (this.payInfo.contractCount == 1) {
        this.claimForm.payMoney = this.payInfo.noConfirmMoney
        this.payMoneyDisabled = true
      } else {
        this.claimForm.payMoney = ''
        this.payMoneyDisabled = false
      }
      if (val.checkStatus == 1) {
        api.newWatersIncomeCont().then(res => {
          if (res.code == 200) {
            if (res.data.length == 0) {
              Toast.fail('该收款信息暂无签约合同记录，请先完善客户合同信息再确认认领。')
              return
            }
            this.claimVisible = true
            this.newIncomeContList = res.data
            this.contractId = res.data[0].contractId
            this.claimForm.contractName = res.data[0].contractNum + '  ' + res.data[0].contractName
            this.contInfo = res.data[0]
            this.getIncomeType(this.contractId)
          }
        })
      } else {
        api.newIncomeCont({ [this.type]: val[type], custName: val.custName }).then(res => {
          if (res.code == 200) {
            if (res.data.length == 0) {
              Toast.fail('该收款信息暂无签约合同记录，请先完善客户合同信息再确认认领。')
              return
            }
            this.claimVisible = true
            this.newIncomeContList = res.data
            this.contractId = res.data[0].contractId
            this.claimForm.contractName = res.data[0].contractNum + '  ' + res.data[0].contractName
            this.contInfo = res.data[0]
            this.getIncomeType(this.contractId)
          }
        })
      }
    },
    getIncomeType(id) {
      api.getIncomeType({ contractId: id }).then(response => {
        if (response.code === 200) {
          this.claimForm.incomeType = response.data
        } else {
          Toast.fail(response.msg)
        }
      })
    },
    getSum() {
      if (Number(this.claimForm.payMoney) + this.payInfo.confirmMoney > this.payInfo.payMoney) {
        Toast.fail('确认金额不能大于收款金额')
        this.claimForm.payMoney = ''
      }
    },
    // 返回布尔值
    beforeRead(file) {
      const imgArr = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp', 'image/webp', 'image/svg+xml', 'image/vnd.adobe.photoshop']
      if (!imgArr.some((item) => { return file.type === item })) {
        Toast.fail('请上传 图片 文件')
        return false
      }
      return true
    },
    onOversize(file) {
      console.log(file)
      Toast.fail('文件大小不能超过 10mb')
    },
    async uploadPictureFiles(file) {
      const _file = file.file
      // 通过 FormData 对象上传文件
      var formData = new FormData()
      formData.append('file', _file)
      await payment.uploadContractFile(formData)
        .then((res) => {
          if (res.code === 200) {
            this.claimForm.payImg = res.url
            this.pictureList = []
            this.pictureList.push({ url: res.url })
            Toast.success(res.msg)
          } else {
            Toast.fail(res.msg)
          }
        })
        .catch(function (error) {
          console.error(error)
          Toast.fail(error)
        })
    },
    handleRemove(file) {
      this.claimForm.payImg = ''
      this.pictureList = []
      return true
    },
    // 认领
    async claimBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.claimForm.validate()
          this.claimForm[type] = this.payInfo[type]
          this.claimForm.contractId = this.contInfo.contractId
          this.claimForm.status = this.payInfo.checkStatus == 1 ? 2 : 1
          if (this.isObjection) {
            api.noAgreeMatch(this.claimForm).then(res => {
              if (res.code == 200) {
                Toast.success('异议提交成功!')
                this.claimVisible = false
                setTimeout(() => {
                  this.$router.push({
                    path: '/cont/payment/paymentList',
                    active: '5'
                  })
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            })
          } else {
            api.addNewIncomeDetail(this.claimForm).then(res => {
              if (res.code == 200) {
                this.claimVisible = false
                Toast.success('认领成功!')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            })
          }
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    getOptions() {
      // 框架类型
      this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      this.getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      this.getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      this.getDicts('credit_cycle_type').then(res => {
        this.options.creditCycleTypeOptions = res.data
      })
      this.getDicts('sys_money_type').then(res => {
        this.options.fundTypeOptions = this.setDictToInt(res)
      })
    },
    showImg(val) {
      this.imageArr = []
      this.imageArr.push(this.detailInfo[val])
      this.imageShow = true
    },
    // 分账
    addExecutive() {
      const peo = {
        fundType: null,
        fundTypeName: null,
        rechargeMoney: null,
        payMoney: null
      }
      this.claimForm.flowList.push(peo)
      const res = this.activeNames.some(item => {
        return this.claimForm.flowList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.claimForm.flowList.length - 1)
      }
    },
    deleteExecutive(item) {
      this.claimForm.flowList.splice(item, 1)
    },
    // 计算账户币或者充值金额
    getPayMoney(type, val, index) {
      const params = {
        contractId: this.contInfo.contractId,
        [this.type]: this.contNewIncomeId,
        fundType: this.claimForm.flowList[index].fundType
      }
      if (type == 'payMoney') {
        params.payMoney = val
        if (this.claimForm.flowList[index].fundType == 1 || this.claimForm.flowList[index].fundType == 2) {
          channel.getPayMoney(params).then(res => {
            if (res.code == 200) {
              this.claimForm.flowList[index].rechargeMoney = res.data
            } else {
              Toast.fail(res.msg)
            }
          })
        } else {
          this.claimForm.flowList[index].rechargeMoney = null
        }
      } else if (type == 'rechargeMoney') {
        params.rechargeMoney = val
        channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.claimForm.flowList[index].payMoney = res.data
          } else {
            Toast.fail(res.msg)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import url("@/style/index.less");

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
/deep/.van-list{
  padding: 0;
}
.tagTitle{
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
}
</style>
